import {css, StyleSheet} from 'aphrodite';
import moment from 'moment';
import React from 'react';

import {InternalLink as InternalLinkType} from 'notebook/mediocre/MediocreConstants';
import InternalLink from 'notebook/mediocre/mentions/InternalLink';
import * as DateUtil from 'util/DateUtil';

interface DatetimeValueProps {
  datetimeValue: moment.MomentInput | null;
  canHighlight?: boolean;
}

export default function DatetimeValue({
  datetimeValue,
  canHighlight = false,
}: DatetimeValueProps): JSX.Element {
  const internalLink: InternalLinkType = {
    iconId: 'eln-timestamp',
    name:
      datetimeValue != null && datetimeValue !== ''
        ? DateUtil.readableTime(datetimeValue, {showSeconds: true, showTimezoneOffset: true})
        : 'Invalid Datetime', // Moment will return "Invalid Date" but we need to display that it is a datetime
  };
  return <InternalLink internalLink={internalLink} className={css(canHighlight && styles.highlightable)} />;
}

const styles = StyleSheet.create({
  highlightable: {
    userSelect: 'unset',
  },
});
